export default __webpack_public_path__ + "static/media/E9Map.341100f8.png";